import { animate, style, transition, trigger } from '@angular/animations';

/**
 * Animação de entrada/saída de cada linha das listas do
 * `ai-dual-list-selector`. Ao mover ou filtrar itens, as linhas entram com um
 * leve fade + deslize e saem da mesma forma — deixando a movimentação fluida.
 *
 * Espelha o padrão de `multi-select-input.animation.ts`: trigger isolado,
 * aplicado via `[@dualListItem]` em cada item do `@for`, com `:enter`/`:leave`.
 */
export const dualListItem = trigger('dualListItem', [
    transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-4px)' }),
        animate(
            '150ms ease',
            style({ opacity: 1, transform: 'translateY(0)' }),
        ),
    ]),
    transition(':leave', [
        animate(
            '120ms ease',
            style({ opacity: 0, transform: 'translateY(-4px)' }),
        ),
    ]),
]);

/** Duração (ms) da saída — útil para sincronizar operações assíncronas. */
export const DUAL_LIST_ITEM_FADE_MS = 120;
